import LoadingButton from 'components/LoadingButton.vue';
import Button from 'components/Form/Button.vue';
import NavBar from 'components/NavBar.vue';
import Alerter from 'components/Alerter.vue';
import EditMenu from 'components/EditMenu.vue';
import Info from 'components/Info.vue';
import ChangeTracker from 'components/ChangeTracker.vue';

export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    Vue.component('loading-button', LoadingButton);
    Vue.component('form-button', Button);
    Vue.component('nav-bar', NavBar);
    Vue.component('alerter', Alerter);
    Vue.component('edit-menu', EditMenu);
    Vue.component('info', Info);
    Vue.component('change-tracker', ChangeTracker);
  }
};
